export enum DeliveryOptions {
  STANDARD = 'STANDARD',
  EXPRESS = 'EXPRESS',
}

export interface DeliveryDateRange {
  minimum: string
  maximum: string
}

export type DeliveryDetailsType = {
  [key in DeliveryOptions]: {
    estimated_delivery_date: DeliveryDateRange
    is_delivered_by_date: boolean
  }
}

export type DeliveryDetailsByColorType = Record<string, DeliveryDetailsType>

export default DeliveryDetailsByColorType
